export * from './tab4.component'